import { Center, useColorMode } from "@chakra-ui/react";
import Image from "next/image";
import Link from "next/link";

const DiscoverIconSM = () => {
  const { colorMode } = useColorMode();

  return (
    <Link href={`/`}>
      <Center mb={100} mt={100}>
        <Image
          src={
            colorMode === "dark"
              ? "/SC Icon_B_White.svg"
              : "/SC Icon_B_Black.svg"
          }
          width={30}
          height={500}
          alt="Discover more Songcards"
        />
      </Center>
    </Link>
  );
};

export default DiscoverIconSM;
